export default {
  className: '_User',
  fields: [
    {
      name: 'head'
    },
    {
      name: 'username',
      tooltip: '初始密码为123456',
      validators: [(value) => value ? null : '账号不可为空']
    },
    {
      name: 'nickName'
    }
  ],
  search: [
    'username',
    'nickName'
  ],
  action: {
    export: false,
    reset: {
      text: '重置密码',
      type: 'row',
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '你确定要重置密码吗?')
        let rs = await vm.$modelAjax.put(modelName, record.objectId, {
          password: '123456'
        }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '重置密码失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '密码已被重置为123456'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        }
      }

    }
  },
  hooks: {
    beforeFetch ({ where }) {
      // 增加一个查询条件，仅查询激活的用户
      where.status = 'admin'
    },
    beforeInsert ({ data }) {
      data.password = '123456'
      data.status = 'admin'
    }
  }
}
